import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { ToastProvider } from "~/components/ui/Toast";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: () => (
    <ToastProvider>
      <Outlet />
    </ToastProvider>
  ),
});
